<script>

import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";
import axios from 'axios';
//import DataTable from 'datatables.net-vue3';
import moment from 'moment';

export default {
    page: {
        title: "Customer Check",
        meta: [
            {
                name: "description",
                content: appConfig.description,
            },
        ],
    },
    data() {
        return {
            title: "Customer Check",
            customercheck_data: [],
            contractstatuslist: [],
            dummy: 0,
            customer_id : '',
            order_id : '',
            customer_fullname : '',
            program_name : '',
            eligibility_check : '',
            eligibility_check_date : '',
            credit_check : '',
            credit_check_date : '',
            credit_check_result : '',
            age_check : '',
            age_check_date : '',
            salary_check : '',
            salary_check_date : '',
            active_customer_check : '',
            active_customer_check_date : '',            
            internal_blacklist_check : '',               
            internal_blacklist_check_date : '',           
            kyc_check : '',      
            kyc_check_date : '',              
            kyc_score : '',          
            tnc_agreemnet : '',  
            tnc_agreemnet_date : '',
            kycMedia1 : '',
            kycMedia2 : '',
            namerperic : '',
            tnc_agreemnet_date_time:'',

            cloudFrontURL: process.env.VUE_APP_BUCKET,
        };
    },

    methods: {
        format_date(value){
            if (value) {
                return moment(String(value)).format('YYYY-MM-DD')
            }
        },
        get_contract_details_by_id(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'customer/customercheckdetails/'+this.$route.params.cid)
            .then(response => {
                if (response) {
                    this.loadingRoles=false;
                    this.customercheck_data = response.data;
                    this.customer_id = this.customercheck_data[0].customer_id;
                    this.order_id = this.customercheck_data[0].order_id;
                    this.customer_fullname = this.customercheck_data[0].first_name+' '+this.customercheck_data[0].last_name;
                    this.namerperic = this.customercheck_data[0].name_as_per_nric;
                    this.program_name = this.customercheck_data[0].program_name;
                    this.eligibility_check = this.customercheck_data[0].eligibility_check;
                    this.eligibility_check_date = this.format_date(this.customercheck_data[0].eligibility_check_date);
                    this.credit_check = this.customercheck_data[0].credit_check;
                    this.credit_check_date = this.format_date(this.customercheck_data[0].credit_check_date);
                    this.credit_check_result = this.customercheck_data[0].credit_check_result;
                    this.age_check = this.customercheck_data[0].age_check;
                    this.age_check_date = this.format_date(this.customercheck_data[0].age_check_date);
                    this.salary_check = this.customercheck_data[0].salary_check;
                    this.salary_check_date = this.format_date(this.customercheck_data[0].salary_check_date);
                    this.active_customer_check = this.customercheck_data[0].active_customer_check;
                    this.active_customer_check_date = this.format_date(this.customercheck_data[0].active_customer_check_date);               
                    this.internal_blacklist_check = this.customercheck_data[0].internal_blacklist_check;                
                    this.internal_blacklist_check_date = this.format_date(this.customercheck_data[0].internal_blacklist_check_date);              
                    this.kyc_check = this.customercheck_data[0].kyc_check;              
                    this.kyc_check_date = this.format_date(this.customercheck_data[0].kyc_check_date);              
                    this.kyc_score = this.customercheck_data[0].kyc_score;              
                    this.tnc_agreemnet = this.customercheck_data[0].tnc_agreemnet;              
                    this.tnc_agreemnet_date = this.format_date(this.customercheck_data[0].tnc_agreemnet_date);
                    this.tnc_agreemnet_date_time = this.customercheck_data[0].tnc_agreemnet_date;                
                    this.kycMedia1 = this.customercheck_data[0].kycMedia1;              
                    this.kycMedia2 = this.customercheck_data[0].kycMedia2;              
                    console.log(this.customercheck_data);
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
        },

        update_customer_contract(e)
        {
            this.ButtonSeen=true;
            e.preventDefault()
            
            const posting_ = {                
                name: this.name,
                branch_code: this.branch_code,
                channel_partner_id: this.channel_partner_id,
                email: this.email,
                email2: this.email2,
                phone_no: this.phone_no,
                operating_hour: this.operating_hour,
                address: this.address,
                city: this.city,
                postcode: this.postcode,
                state: this.state,
                country_id: this.country_id,
            };

            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.post(process.env.VUE_APP_API_BASEURL+'branch/update/'+this.$route.params.id, posting_)
            .then(response => {
                if (response) {
                  this.ButtonSeen=false; 
                  alert(response.data.msj);                       
                }
                else{
                    this.ButtonSeen=false;
                    console.log('tak ok');
                }
            });
        },

        //raw data----------------------------------------------------------
        get_contract_status(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'contractstatus/list')
            .then(response => {
                if (response) {
                    this.loadingRoles=false;
                    this.contractstatuslist = response.data;
                    console.log(this.contractstatuslist);
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
        },

        //raw data----------------------------------------------------------
    },

    components: {
        Layout,
        PageHeader, 
    },

    mounted() {     
        this.get_contract_details_by_id();   
        this.get_contract_status();
        //this.get_country();
           
    },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-xl-6">
        <div class="card">
          <div class="card-body">
            <div class="live-preview">
                <div class="row mb-3">
                  <div class="col-lg-4">
                    <label for="customer_fullname" class="form-label">Customer Name</label>
                  </div>
                  <div class="col-lg-8">
                    <input v-model='namerperic' type="text" class="form-control" id="customer_fullname" />
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-lg-4">
                    <label for="program_name" class="form-label">Program</label>
                  </div>
                  <div class="col-lg-8">
                    <input v-model='program_name' type="text" class="form-control" id="program_name" />
                  </div>
                </div>
                <!--div class="row mb-3">
                  <div class="col-lg-4">
                    <label for="channel_partner_id" class="form-label">Finco</label>
                  </div>
                  <div class="col-lg-8">
                    <input v-model='contract_end_date' type="text" class="form-control" id="branch_code" />
                  </div>
                </div-->    
                <hr class="my-4 text-muted">
            </div>
          </div>
        </div> 

        <div class="card">
            <div class="card-header">
            <div class="d-flex">
              <h5><i class="ri-function-fill text-muted align-bottom me-1"></i>PROGRAM ELIGIBILITY</h5>
            </div>
          </div>
          <div class="card-body">
            <div class="live-preview">
                <div class="row mb-3">
                  <div class="col-lg-4">
                    <label for="branch_code" class="form-label">Program Eligibility Check</label>
                  </div>
                  <div class="col-lg-8">
                    <select v-model="eligibility_check" class="form-select mb-3" arial-label="Default select example" disabled>
                        <option value="0">
                            ----
                        </option>
                        <option value="2">
                            FAILED
                        </option>
                        <option value="1">
                            PASSED
                        </option>
                    </select>
                  </div>
                </div> 
                <div class="row mb-3">
                  <div class="col-lg-4">
                    <label for="eligibility_check_date" class="form-label">Program Eligibility Check Date</label>
                  </div>
                  <div class="col-lg-8">
                    <input v-model="eligibility_check_date" type="date" class="form-control" id="eligibility_check_date" readonly />
                  </div>
                </div>              
                <hr class="my-4 text-muted">
            </div>
          </div>
        </div> 

        <div class="card">
            <div class="card-header">
            <div class="d-flex">
              <h5><i class="ri-function-fill text-muted align-bottom me-1"></i>KYC</h5>
            </div>
          </div>
          <div class="card-body">
            <div class="live-preview">
                <div class="row mb-3">
                  <div class="col-lg-4">
                    <label for="kyc_check" class="form-label">KYC Check</label>
                  </div>
                  <div class="col-lg-8">
                    <select v-model="kyc_check" class="form-select mb-3" arial-label="Default select example" disabled>
                        <option value="0">
                            ----
                        </option>
                        <option value="2">
                            FAILED
                        </option>
                        <option value="1">
                            PASSED
                        </option>
                    </select>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-lg-4">
                    <label for="kyc_check_date" class="form-label">KYC Check Date</label>
                  </div>
                  <div class="col-lg-8">
                    <input v-model='kyc_check_date' type="date" class="form-control" id="kyc_check_date" readonly/>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-lg-4">
                    <label for="kyc_score" class="form-label">KYC Score</label>
                  </div>
                  <div class="col-lg-8">
                    <textarea v-model="kyc_score" rows="4" class="form-control" id="kyc_score" ></textarea>
                  </div>
                </div> 
                <div class="row mb-3">
                  <div class="col-lg-4">
                    <label for="kyc_check_date" class="form-label">NRIC</label>
                  </div>
                  <div v-if="kycMedia1" class="col-lg-8">
                    <a v-bind:href="cloudFrontURL+kycMedia1" target="_blank" rel="noreferrer noopener">Click Here to View</a>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-lg-4">
                    <label for="kyc_check_date" class="form-label">Customer Selfie</label>
                  </div>
                  <div v-if="kycMedia2" class="col-lg-8">
                    <a v-bind:href="cloudFrontURL+kycMedia2" target="_blank" rel="noreferrer noopener">Click Here to View</a>
                  </div>
                </div>
                            
                <hr class="my-4 text-muted">
            </div>
            <div class="text-end col-lg-12">
              <a @click="$router.go(-1)" class="btn btn-success">Back</a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;                      
            </div>
          </div>
          
        </div>        

        <div class="card">
            <div class="card-header">
            <div class="d-flex">
              <h5><i class="ri-function-fill text-muted align-bottom me-1"></i>T & C</h5>
            </div>
          </div>
          <div class="card-body">
            <div class="live-preview">

              <div class="row mb-3">
                  <div class="col-lg-4">
                    <label for="kyc_check_date" class="form-label">T & C Agreement</label>
                  </div>

                  <div class="col-lg-8" v-if="tnc_agreemnet == 1">
                    <input value='AGREE' class="form-control" id="kyc_check_date" readonly/>
                  </div>
                  <div class="col-lg-8" v-else>
                    <input value='DISAGREE' class="form-control" id="kyc_check_date" readonly/>
                  </div>

                </div>
          
                <div class="row mb-3">
                  <div class="col-lg-4">
                    <label for="kyc_check_date" class="form-label">T & C Agreement Date</label>
                  </div>
                  <div class="col-lg-8">
                    <input v-model='tnc_agreemnet_date' type="date" class="form-control" id="kyc_check_date" readonly/>
                  </div>
                </div>

                <div class="row mb-3">
                  <div class="col-lg-4">
                    <label for="kyc_check_date" class="form-label">Tnc Acknowledge Click Date Time</label>
                  </div>
                  <div class="col-lg-8">
                    <input v-model='tnc_agreemnet_date_time'  class="form-control" id="kyc_check_date" readonly/>
                  </div>
                </div>
                
       
            </div>
       
          </div>
          
        </div>      

      </div>

      <div class="col-xl-6">    
        <div class="card">
          <div class="card-header">
            <div class="d-flex">
              <h5><i class="ri-function-fill text-muted align-bottom me-1"></i>BLACKLIST INFO</h5>
            </div>
          </div>
          <div class="card-body">
            <div>
                <div class="row g-4">
                   
                    <div class="col-lg-4">
                        <label for="active_customer_check" class="form-label">Active Contract Check</label>
                    </div>
                    <div class="col-lg-8">
                        <select v-model="active_customer_check" class="form-select mb-3" arial-label="Default select example" disabled>
                          <option value="0">
                            ----
                          </option>
                          <option value="2">
                              FAILED
                          </option>
                          <option value="1">
                              PASSED
                          </option>
                        </select>
                    </div>
                
                    <div class="col-lg-4">
                        <label for="active_customer_check" class="form-label">Active Contract Check Date</label>
                    </div>
                    <div class="col-lg-8">
                        <input v-model='internal_blacklist_check_date' type="date" class="form-control" id="active_customer_check" readonly/>
                    </div>

                    <div class="col-lg-4">
                        <label for="internal_blacklist_check" class="form-label">Internal Black List Check</label>
                    </div>
                    <div class="col-lg-8">
                        <select v-model="internal_blacklist_check" class="form-select mb-3" arial-label="Default select example" disabled>
                          <option value="0">
                            ----
                          </option>
                          <option value="2">
                              FAILED
                          </option>
                          <option value="1">
                              PASSED
                          </option>
                        </select>
                    </div>
                    
                    <div class="col-lg-4">
                        <label for="internal_blacklist_check" class="form-label">Internal Black List Check Date</label>
                    </div>
                    <div class="col-lg-8">
                        <input v-model='internal_blacklist_check_date' type="date" class="form-control" id="internal_blacklist_check" readonly/>
                    </div>  
                </div>
                
                <hr class="my-4 text-muted">
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-header">
            <div class="d-flex">
              <h5><i class="ri-function-fill text-muted align-bottom me-1"></i>CREDIT</h5>
            </div>
          </div>
          <div class="card-body">
            <div>
                <div class="row g-4">
                   
                    <div class="col-lg-4">
                        <label for="credit_check" class="form-label">Credit Check</label>
                    </div>
                    <div class="col-lg-8">
                        <select v-model="credit_check" class="form-select mb-3" arial-label="Default select example" disabled>
                            <option value="0">
                               ----
                            </option>
                            <option value="2">
                                FAILED
                            </option>
                            <option value="1">
                                PASSED
                            </option>
                        </select>
                    </div>
            
                      <div class="col-lg-4">
                            <label for="credit_check_date" class="form-label">Credit Check Date</label>
                        </div>
                        <div class="col-lg-8" v-if="credit_check == 1 || credit_check == 2">
                            <input v-model='credit_check_date' type="date" class="form-control" id="credit_check_date" readonly/>
                        </div>
                        <div class="col-lg-8" v-if="credit_check == 0">
                            <input v-model='credit_check_date' type="date" class="form-control" id="credit_check_date" readonly/>
                        </div>

                    <div class="col-lg-4">
                        <label for="age_check" class="form-label">Customer Age Check Valid</label>
                    </div>
                    <div class="col-lg-8">
                        <select v-model="age_check" class="form-select mb-3" arial-label="Default select example" disabled>
                            <option value="0">
                                ----
                            </option>
                            <option value="2">
                                FAILED
                            </option>
                            <option value="1">
                                PASSED
                            </option>
                        </select>
                    </div>
                    
                    <div class="col-lg-4">
                        <label for="age_check_date" class="form-label">Customer Age Check Date</label>
                    </div>
                    <div class="col-lg-8">
                        <input v-model='age_check_date' type="date" class="form-control" id="age_check_date" readonly/>
                    </div> 

                    <!--div class="col-lg-4">
                        <label for="salary_check" class="form-label">Salary Income Check</label>
                    </div>
                    <div class="col-lg-8">
                        <select v-model="salary_check" class="form-select mb-3" arial-label="Default select example" required>
                            <option value="0">
                                ----
                            </option>
                            <option value="2">
                                FAILED
                            </option>
                            <option value="1">
                                PASSED
                            </option>
                        </select>
                    </div>
                    
                    <div class="col-lg-4">
                        <label for="salary_check_date" class="form-label">Salary Income Check Valid</label>
                    </div>
                    <div class="col-lg-8">
                        <input v-model='salary_check_date' type="date" class="form-control" id="salary_check_date" readonly/>
                    </div--> 
                </div>
                
                <hr class="my-4 text-muted">
            </div>
          </div>
        </div>
      </div>
      
    </div>
  </Layout>
</template>
